import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=e98e8f9a&"
import script from "./side-menu.vue?vue&type=script&lang=js&"
export * from "./side-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports